import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { Course } from 'types';

import { apiQuery } from '../../query';

import { CourseeResponse } from './types';

const tagTypes = ['COURSES'];

export const coursesApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'coursesApi',
  endpoints: (build) => ({
    active: build.query<Course, void>({
      providesTags: tagTypes,
      transformResponse: (response: CourseeResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.COURSE_DETAILS,
      }),
    }),
  }),
});

export const { useActiveQuery } = coursesApi;
